// app.routes.ts
import { Route } from '@angular/router';
import { ClaimGuard } from './core/guards/claim.guard';
import { StudentOwnershipGuard } from './care/guards/student-ownership.guard';
import { PAGES_ROUTES } from '@awo-care/pages';
import {
  ImpressumComponent,
  CookiesPageComponent,
  NotFoundComponent,
} from '@awo-care/shared-ui';
import { CostUnitHandlerComponent } from './core/components/cost-unit-handler.component';
import { CONTRACT_DECLARATION_ROUTES } from './contract-declarations/contract-declaration.routes';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/care',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.routes').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: 'care',
    canActivate: [ClaimGuard],
    loadChildren: () =>
      import('./care/care.routes').then((mod) => mod.CARE_ROUTES),
  },
  {
    path: 'registration',
    canActivate: [ClaimGuard],
    loadChildren: () =>
      import('./registration/registration.routes').then(
        (mod) => mod.REGISTRATION_ROUTES
      ),
    data: { title: $localize`:@@registration.pageTitle:Anmeldung` },
  },
  {
    path: 'contract',
    canActivate: [ClaimGuard, StudentOwnershipGuard],
    loadComponent: () =>
      import('./contract/contract.component').then(
        (mod) => mod.ContractComponent
      ),
    data: { title: $localize`:@@app.contractTitle:Vertrag abschließen` },
  },
  {
    path: 'settings',
    canActivate: [ClaimGuard],
    loadChildren: () =>
      import('./settings/settings.routes').then((mod) => mod.SETTINGS_ROUTES),
    data: { requiredClaims: ['user'] },
  },
  {
    path: 'sendErrorMessage',
    loadComponent: () =>
      import(
        './core/components/send-error-message/send-error-message.component'
      ).then((mod) => mod.SendErrorMessageCustomerComponent),
    data: { title: $localize`:@@app.sendErrorMessageTitle:Fehler melden` },
  },
  {
    path: 'kostenstelle',
    component: CostUnitHandlerComponent,
  },
  // Kündigung (§ 312k BGB) und Widerruf (§ 356a BGB) müssen ohne Anmeldung
  // erreichbar sein — deshalb Top-Level und ohne Guard (#1120).
  ...CONTRACT_DECLARATION_ROUTES,
  {
    path: '',
    children: PAGES_ROUTES,
  },
  {
    path: 'legal',
    children: [
      {
        path: 'imprint',
        component: ImpressumComponent,
        data: { title: $localize`:@@footer.impressum.title:Impressum` },
      },
      {
        path: 'privacy-policy',
        redirectTo: '/care/data-privacy-view',
      },
      {
        path: 'cookies',
        component: CookiesPageComponent,
        data: { title: $localize`:@@cookiesPageTitle:Cookie-Richtlinie` },
      },
    ],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    data: { title: $localize`:@@app.notFoundTitle:Seite nicht gefunden` },
  },
  {
    path: '**',
    redirectTo: '/care',
  },
];
